/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Team_Removed_ToastInputs */

const en_team_removed_toast = /** @type {(inputs: Team_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} removed.`)
};

const es_team_removed_toast = /** @type {(inputs: Team_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} eliminado.`)
};

const fr_team_removed_toast = /** @type {(inputs: Team_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} retiré.`)
};

const de_team_removed_toast = /** @type {(inputs: Team_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entfernt.`)
};

const id_team_removed_toast = /** @type {(inputs: Team_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} telah dihapus.`)
};

/** @type {(inputs: Team_Removed_ToastInputs) => LocalizedString} */
const ja_team_removed_toast = en_team_removed_toast;

/** @type {(inputs: Team_Removed_ToastInputs) => LocalizedString} */
const zh_team_removed_toast = en_team_removed_toast;

/** @type {(inputs: Team_Removed_ToastInputs) => LocalizedString} */
const ar_team_removed_toast = en_team_removed_toast;

/** @type {(inputs: Team_Removed_ToastInputs) => LocalizedString} */
const it_team_removed_toast = en_team_removed_toast;

/** @type {(inputs: Team_Removed_ToastInputs) => LocalizedString} */
const ru_team_removed_toast = en_team_removed_toast;

/** @type {(inputs: Team_Removed_ToastInputs) => LocalizedString} */
const pt_team_removed_toast = en_team_removed_toast;

/** @type {(inputs: Team_Removed_ToastInputs) => LocalizedString} */
const ko_team_removed_toast = en_team_removed_toast;

/**
* | output |
* | --- |
* | "{name} removed." |
*
* @param {Team_Removed_ToastInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_removed_toast = /** @type {((inputs: Team_Removed_ToastInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Removed_ToastInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_removed_toast(inputs)
	if (locale === "es") return es_team_removed_toast(inputs)
	if (locale === "fr") return fr_team_removed_toast(inputs)
	if (locale === "de") return de_team_removed_toast(inputs)
	if (locale === "ja") return ja_team_removed_toast(inputs)
	if (locale === "zh") return zh_team_removed_toast(inputs)
	if (locale === "ar") return ar_team_removed_toast(inputs)
	if (locale === "id") return id_team_removed_toast(inputs)
	if (locale === "it") return it_team_removed_toast(inputs)
	if (locale === "ru") return ru_team_removed_toast(inputs)
	if (locale === "pt") return pt_team_removed_toast(inputs)
	return ko_team_removed_toast(inputs)
});